import deburr from "lodash/deburr"

export const sanitizeSubDomain = value =>
  deburr((value || "").replace(/\s/g, "-").toLowerCase())
